import { Link, useLocation } from "react-router";
import { CUSTOM_MSG, MESSAGE_ID_PARAM } from "../../constants/messages";
import HomeFooter from "../../components/layouts/HomeFooter";
import { createElement } from "react";
import IconLogoutDone from "../../components/icons/IconLogoutDone";
import IconLogoutAndSuccess from "../../components/icons/IconLogoutAndSuccess";
import IconLogoutAndError from "../../components/icons/IconLogoutAndError";
import IconLogoutSystemError from "../../components/icons/IconLogoutSystemError";

const LogoutDone = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const messageId = queryParams.get("messageId");
  const messageType = queryParams.get("messageType") ?? "0";
  const erklaeringId = queryParams.get("erklaeringId");
  const erklaeringIndsendes = queryParams.get("erklaeringIndsendes");
  const signingUser = queryParams.get("signingUser");
  const message = MESSAGE_ID_PARAM[parseInt(messageId ?? "0")];
  const messageHtml = createElement("div", {
    className: "fw-medium mx-auto mt-5",
    dangerouslySetInnerHTML: { __html: message },
  });

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="container-xxl text-center d-flex align-items-center justify-content-center flex-grow-1">
        <div className="col-12 col-lg-7 py-5">
          {messageType === "0" && (
            <>
              <div className="mb-5 text-dark">
                <IconLogoutDone height={100} />
              </div>
              <h1 className="display-1 fw-bold">
                {CUSTOM_MSG.logoutDoneType0}
              </h1>
            </>
          )}
          {messageType === "1" && (
            <>
              <div className="mb-5 text-dark">
                <IconLogoutAndSuccess height={100} />
              </div>
              <h1 className="display-1 fw-bold">
                {CUSTOM_MSG.logoutDoneType1}
              </h1>
            </>
          )}
          {messageType === "2" && (
            <>
              <div className="mb-5 text-dark">
                <IconLogoutAndError height={100} />
              </div>
              <h1 className="display-1 fw-bold">
                {CUSTOM_MSG.logoutDoneType2}
              </h1>
            </>
          )}
          {messageType === "3" && (
            <>
              <div className="mb-5 text-dark">
                <IconLogoutSystemError height={100} />
              </div>
              <h1 className="display-1 fw-bold">
                {CUSTOM_MSG.logoutDoneType3}
              </h1>
            </>
          )}
          {messageHtml}
          {erklaeringId !== null && messageId !== "13" && (
            <p>
              Erklæringen blev godkendt{" "}
              {erklaeringIndsendes?.toLocaleLowerCase() === "true"
                ? " og indsendt "
                : ""}{" "}
              af {signingUser}.
            </p>
          )}
          <div className="mt-5">
            <Link
              to={"/login"}
              style={{ border: "none" }}
              className="link-primary fs-4 text-decoration-underline"
            >
              Tilbage til forsiden
            </Link>
          </div>
        </div>
      </div>
      <HomeFooter />
    </div>
  );
};

export default LogoutDone;
